import React, { Fragment, useContext, useEffect } from 'react';
import classNames from 'classnames/bind';

import SearchTabsContainer from 'components/SearchTabsContainer';
import Container from 'components/Container';
import ServicesList from 'components/ServicesList';
import TopRefs from 'components/TopRefs';
import LatestBulletins from 'components/LatestBulletins';

import { StaticTextContext } from 'context/StaticTextContext';
import { SearchContext } from 'context/SearchContext';
import { CountryContext } from 'context/CountryContext';

import { isGlobalSite } from 'utils/currentLanguage';
import { isTechAssistPage, isBlock } from 'utils/browserHistory';

import styles from './Home.module.scss';

const cx = classNames.bind(styles);

const Home = () => {
  const { labels } = useContext(StaticTextContext);
  const {
    setManuCar,
    setManuTruck,
    setIsSelectedCar,
    setIsSelectedModel,
    setIsSelectedManu,
  } = useContext(SearchContext);
  const { setCurrentCountry } = useContext(CountryContext);

  useEffect(() => {
    const query = window.location.search;
    if (!isBlock) window.scrollTo(0, 0);

    // @todo: now it is implemented in a bad way. Need to refactor it.
    // ----
    setIsSelectedCar(false);
    setIsSelectedModel(false);
    setIsSelectedManu(false);
    // ----

    if (isGlobalSite && !query.length) {
      setCurrentCountry('.com');
      setManuCar(null);
      setManuTruck(null);
    }
  }, []);

  return (
    <div className={cx('home', { 'techassist-block': isBlock })}>
      <div className={cx('search-container', { 'bg-gray': !isBlock })}>
        <Container className={cx('mobile-container')}>
          {isTechAssistPage && (
            <h1 className={cx('title')}>{labels.homePageTitle}</h1>
          )}
          <SearchTabsContainer />
        </Container>

        {isTechAssistPage && (
          <Fragment>
            <ServicesList />
            <TopRefs />
            <LatestBulletins className={cx('latest-bulletins')} />
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/Home.js